export function buildVersion(env:Record<string,unknown>){
 const rc=String(env.VITE_RELEASE_NAME??'').trim(),sha=String(env.VITE_GIT_SHA??'').trim(),date=String(env.VITE_BUILD_DATE??'').trim();
 return /^RC\d+(?:\.\d+)*$/.test(rc)&&/^[a-f0-9]{7,40}$/i.test(sha)&&/^\d{4}-\d{2}-\d{2}$/.test(date)?`${rc} · ${sha.slice(0,7)} · ${date}`:null;
}
export function BuildVersion(){const version=buildVersion(import.meta.env);return version?<p className="profile-build-version">{version}</p>:null;}
